An array of contact persons for the position.

At least one contact person must be provided.
A maximum of 10 contact people may be provided.
